var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/email_passthru.tsx";
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import snackbar from 'soapbox/actions/snackbar';
import { confirmEmailVerification } from 'soapbox/actions/verification';
import { Icon, Spinner, Stack, Text } from 'soapbox/components/ui';
import { useAppDispatch } from 'soapbox/hooks';
const Statuses = {
  IDLE: 'IDLE',
  SUCCESS: 'SUCCESS',
  GENERIC_FAIL: 'GENERIC_FAIL',
  TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED'
};
const messages = defineMessages({
  emailConfirmedHeading: {
    "id": "email_passthru.confirmed.heading",
    "defaultMessage": "Email Confirmed!"
  },
  emailConfirmedBody: {
    "id": "email_passthru.confirmed.body",
    "defaultMessage": "Close this tab and continue the registration process on the {bold} from which you sent this email confirmation."
  },
  genericFailHeading: {
    "id": "email_passthru.generic_fail.heading",
    "defaultMessage": "Something Went Wrong"
  },
  genericFailBody: {
    "id": "email_passthru.generic_fail.body",
    "defaultMessage": "Please request a new email confirmation."
  },
  tokenNotFoundHeading: {
    "id": "email_passthru.token_not_found.heading",
    "defaultMessage": "Invalid Token"
  },
  tokenNotFoundBody: {
    "id": "email_passthru.token_not_found.body",
    "defaultMessage": "Your email token was not found. Please request a new email confirmation from the {bold} from which you sent this email confirmation."
  },
  tokenExpiredHeading: {
    "id": "email_passthru.token_expired.heading",
    "defaultMessage": "Token Expired"
  },
  tokenExpiredBody: {
    "id": "email_passthru.token_expired.body",
    "defaultMessage": "Your email token has expired. Please request a new email confirmation from the {bold} from which you sent this email confirmation."
  }
});
const Success = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-check.svg'),
    className: "text-primary-600 dark:text-primary-400 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.emailConfirmedHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.emailConfirmedBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 66
      }
    }, "same device")
  })));
};
const GenericFail = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.genericFailHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.genericFailBody)));
};
const TokenNotFound = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenNotFoundHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenNotFoundBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 65
      }
    }, "same device")
  })));
};
const TokenExpired = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenExpiredHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenExpiredBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 64
      }
    }, "same device")
  })));
};
const EmailPassThru = () => {
  const {
    token
  } = useParams();
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [status, setStatus] = React.useState(Statuses.IDLE);
  React.useEffect(() => {
    if (token) {
      dispatch(confirmEmailVerification(token)).then(() => {
        setStatus(Statuses.SUCCESS);
        dispatch(snackbar.success(intl.formatMessage({
          id: 'email_passthru.success',
          defaultMessage: 'Your email has been verified!'
        })));
      }).catch(error => {
        const errorKey = error?.response?.data?.error;
        let message = intl.formatMessage({
          id: 'email_passthru.fail.generic',
          defaultMessage: 'Unable to confirm your email'
        });
        if (errorKey) {
          switch (errorKey) {
            case 'token_expired':
              message = intl.formatMessage({
                id: 'email_passthru.fail.expired',
                defaultMessage: 'Your email token has expired.'
              });
              setStatus(Statuses.TOKEN_EXPIRED);
              break;
            case 'token_not_found':
              message = intl.formatMessage({
                id: 'email_passthru.fail.not_found',
                defaultMessage: 'Your email token is invalid.'
              });
              message = 'Your token is invalid';
              setStatus(Statuses.TOKEN_NOT_FOUND);
              break;
            default:
              setStatus(Statuses.GENERIC_FAIL);
              break;
          }
        }
        dispatch(snackbar.error(message));
      });
    }
  }, [token]);
  switch (status) {
    case Statuses.SUCCESS:
      return /*#__PURE__*/React.createElement(Success, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 148,
          columnNumber: 14
        }
      });
    case Statuses.TOKEN_EXPIRED:
      return /*#__PURE__*/React.createElement(TokenExpired, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 150,
          columnNumber: 14
        }
      });
    case Statuses.TOKEN_NOT_FOUND:
      return /*#__PURE__*/React.createElement(TokenNotFound, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 152,
          columnNumber: 14
        }
      });
    case Statuses.GENERIC_FAIL:
      return /*#__PURE__*/React.createElement(GenericFail, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 14
        }
      });
    default:
      return /*#__PURE__*/React.createElement(Spinner, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 14
        }
      });
  }
};
export default EmailPassThru;